import React from 'react'
import Layout from '../../components/layout'
import Container from '../../components/container'
// import styled from '@emotion/styled'

const UrbanPage = () => {
  return (
    <Layout>
      <Container>
        <p>This is the Urban Page</p>
      </Container>
    </Layout>
  );
}

export default UrbanPage
